import { render } from "./B2bPageConsultInvoiceByLink.vue?vue&type=template&id=09c3f677&scoped=true&lang=pug"
import script from "./B2bPageConsultInvoiceByLink.vue?vue&type=script&lang=js"
export * from "./B2bPageConsultInvoiceByLink.vue?vue&type=script&lang=js"

import "./B2bPageConsultInvoiceByLink.vue?vue&type=style&index=0&id=09c3f677&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c3f677"]])

export default __exports__